import { encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";
import utf8 from "utf8";

class StudentTripStore {
    loading = false;
    total = 0;
    routelist = [];
    specialVehicleList = [];
    totalTripCount = 0;
    rootStore;


    constructor(rootStore) {
        makeObservable(this, {
            loading: observable,
            total: observable,
            routelist: observable,
            totalTripCount: observable,
            specialVehicleList: observable,
            // loadData: action,
            deleteMultipleTrips: action,
            addData: action,
            getSpecialVehicle: action,
            loadTripData: action,
            assignBus: action
        });
        this.rootStore = rootStore;
    }


    async addData(postData) {

        console.log("*************Store*****************", postData)
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi
            .getClient()
            .post("index.php?c=student&a=createMasterTrip", "postData=" + base64Input);
        return response;
    }





    // async deleteRecord({ routeId }) {
    //     const postData = {
    //         routeId: routeId,
    //     };
    //     const base64Input = await base64_encode(JSON.stringify(postData));
    //     var response = await postApi
    //         .getClient()
    //         .post("index.php?c=route&a=studentDeleteNewRoute", "postData=" + base64Input);



    //     return response;
    // }
    async deleteMultipleTrips(data) {
        console.log(data)
        const base64Input = await base64_encode(JSON.stringify(data));
        var response = await postApi
            .getClient()
            .post("index.php?c=student&a=deleteTrip", "postData=" + base64Input);
        return response?.data;
    }
    async getSpecialVehicle(companyId, tripType) {
        var postData = { companyId: companyId, TripType: tripType };
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi
            .getClient()
            .post(
                "index.php?c=vehicle&a=specialVehicles",
                "postData=" + base64Input
            );
        console.log(response?.data?.data, "post")
        this.specialVehicleList = response?.data?.data;
        return response?.data?.data;
    }
    async loadTripData(companyId, offset, limit) {
        this.loading = true;
        var postData = {
            offset: offset,
            limit: limit,
            companyId: companyId,
        };

        const base64Input = await utf8.encode(JSON.stringify(postData));
        const base2 = JSON.stringify(base64_encode(base64Input));

        const response = await postApi
            .getClient()
            .post("index.php?c=student&a=masterTripDetails", "postData=" + base2);
        // return response?.data?.data;
        console.log("******************************************************************")

        this.tripDetails = response?.data?.TripData?.tripDetails;
        this.totalTripCount = parseInt(response?.data?.TripData?.TotalCount);
        this.loading = false;
    }
    async getTripData(tripId, offset, limit) {
        this.loading = true;
        var postData = {
            offset: 0,
            limit: 1,
            tripId: tripId
        };

        const base64Input = await utf8.encode(JSON.stringify(postData));
        const base2 = JSON.stringify(base64_encode(base64Input));

        const response = await postApi
            .getClient()
            .post("index.php?c=student&a=masterTripDetails", "postData=" + base2);

        this.loading = false;
        return response?.data?.TripData?.tripDetails[0];
    }
    async assignBus(data) {
        const base64Input = await base64_encode(JSON.stringify(data));
        var response = await postApi
            .getClient()
            .post("index.php?c=student&a=assignBusToTrip", "postData=" + base64Input);
        return response?.data;
    }
}

export default StudentTripStore;
